module.exports = __webpack_public_path__ + "img/web-P4-0-4.c0262d2c.svg";